var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcPasswordlessAccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.16,
    y1: 0.064,
    x2: 0.86,
    y2: 0.931,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4ee48f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#032471"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3123",
    "data-name": "Rectangle 3123",
    width: 64,
    height: 64,
    transform: "translate(16460 1488)",
    fill: "url(#linear-gradient)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_passwordless_access",
    transform: "translate(-16460 -1488)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "fingerprint-svgrepo-com_1_",
    "data-name": "fingerprint-svgrepo-com (1)",
    d: "M19.839,3.331a30.546,30.546,0,0,1,43.244,34.2,3.022,3.022,0,1,1-5.893-1.341A24.5,24.5,0,0,0,22.506,8.753a3.021,3.021,0,1,1-2.667-5.422ZM13.2,11.694a3.021,3.021,0,0,1,.576,4.23A24.4,24.4,0,0,0,9.4,25.318,107.491,107.491,0,0,1,6.135,37a3.021,3.021,0,1,1-5.7-1.994A101.163,101.163,0,0,0,3.513,23.98,30.446,30.446,0,0,1,8.971,12.27a3.021,3.021,0,0,1,4.23-.576Zm1.043,14.727a19.537,19.537,0,0,1,36.964-3.46,3.022,3.022,0,0,1-5.539,2.417,13.495,13.495,0,0,0-25.531,2.381c-.7,3.086-1.426,5.881-2.187,8.451a3.021,3.021,0,1,1-5.793-1.716c.721-2.429,1.41-5.1,2.091-8.077ZM28.54,23.674a8.528,8.528,0,0,1,13.068,8.967q-1.193,5.312-2.755,10.53a3.022,3.022,0,1,1-5.785-1.748c.947-3.13,1.821-6.477,2.651-10.119a2.485,2.485,0,0,0-3.807-2.614,3.022,3.022,0,1,1-3.372-5.015Zm21.531,7.795a3.021,3.021,0,0,1,2.276,3.613,129.243,129.243,0,0,1-8.774,26.623,3.021,3.021,0,0,1-5.47-2.562,123.171,123.171,0,0,0,8.351-25.4,3.021,3.021,0,0,1,3.617-2.276ZM26.836,34.18a3.021,3.021,0,0,1,2.087,3.73,88,88,0,0,1-7.775,19.312c-.23.415-.463.826-.7,1.237a3.021,3.021,0,0,1-5.229-3.021c.218-.383.435-.765.645-1.148a81.9,81.9,0,0,0,7.243-18.027,3.021,3.021,0,0,1,3.73-2.083ZM12.79,42.228a3.021,3.021,0,0,1,1.547,3.98c-.878,2-1.813,3.867-2.812,5.668a3.021,3.021,0,0,1-5.281-2.933C7.154,47.3,8,45.6,8.81,43.775a3.021,3.021,0,0,1,3.98-1.551Zm45.765,1.188a3.021,3.021,0,0,1,2.079,3.734q-1.476,5.212-3.356,10.3a3.021,3.021,0,1,1-5.664-2.1c1.173-3.162,2.232-6.429,3.207-9.849a3.021,3.021,0,0,1,3.734-2.079ZM33.539,49.58a3.025,3.025,0,0,1,1.615,3.956,90.754,90.754,0,0,1-4.383,9.035,3.021,3.021,0,1,1-5.277-2.937A84.716,84.716,0,0,0,29.584,51.2a3.021,3.021,0,0,1,3.952-1.619Z",
    transform: "translate(16459.951 1487.791)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPasswordlessAccess);
export default __webpack_public_path__ + "static/media/ic_passwordless_access.f5b5fc08328ca39a557be0b9625466eb.svg";
export { ForwardRef as ReactComponent };